<div class="row">
    <img class="success-check" [src]="'../../../assets/icons/ico-info' + (darkMode ? '-dark.svg' : '.svg')">
    <div class="text">{{data.contentText}}</div>
</div>

<div class="details-action" (click)="emitActionClick()" [class.hidden]="!data.showButton">
    View Details
</div>